import React, { useState } from 'react';
import Select from 'react-select';
import Breadcrumb from '../../../../components/Shared/Breadcrumb';
import { Card, CardBody } from '../../../../components/card/card';
import { useTranslation } from 'react-i18next';
import useGetUnitsOfMeasureList from '../../../../hooks/INV/useGetUnitsOfMeasureList';
import useLookupUomClass from '../../../../hooks/Lookups/use-Lookup-Uom_Class';
import NtxTable from '../../../../components/DataTable/NtxTable';
import Loading from '../../../../components/Shared/Loader/Loading';

const Index = () => {
  const [search, setSearch] = useState('');

  const { t, i18n } = useTranslation();
  const [selectedValue, setSelectedValue] = useState(null);

  const { UOMCLASSOPTIONS, loading: loading2, error: error2 } = useLookupUomClass();
  // console.log(UOMCLASSOPTIONS);

  const { UnitsOfMeasureList, loading, error } = useGetUnitsOfMeasureList();

  const filteredSearch = UnitsOfMeasureList?.slice()
    ?.filter(item => {
      const searchLowerCase = search.toLowerCase();
      return (
        item.name?.toLowerCase().includes(searchLowerCase) ||
        item.name2?.toLowerCase().toString().includes(searchLowerCase)
      );
    })
    ?.filter(f => (selectedValue === null ? true : f.class === selectedValue));

  const columns = [
    { title: t('Name'), key: 'Name' },
    { title: t('Code'), key: 'Code' }
  ];

  const tableData = filteredSearch?.map((item: any) => {
    let rowClass;

    return {
      Name: i18n.language === 'ar' ? item.name2 : item.name,
      Code: item.code
    };
  });

  //________________________________
  var BcrumbList = [
    {
      name: 'Home',
     link: ':moduleHome'
    },
    {
      name: 'MeasurementUnits',
      link: null
    }
  ];
  return (
    <div>
      <Breadcrumb BreadcrumbList={BcrumbList} PageName='MeasurementUnits' />

      <Card>
        <Loading loading={loading || loading2} error={error || error2}>
          <CardBody>
            <div className='row mb-2'>
              <div className='col-lg-6'>
                <div className='input-group flex-nowrap'>
                  <span className='input-group-text fw-bold'>{t('Search')}</span>
                  <div className='input-group'>
                    <div className='flex-fill position-relative'>
                      <div className='input-group border-0 '>
                        <div
                          className='input-group-text position-absolute top-0 bottom-0 bg-none border-0 pe-0'
                           
                        >
                          <i className='fa fa-search opacity-5 text-theme'></i>
                        </div>
                        <input
                          type='text'
                          autoComplete='off'
                          className='form-control ps-35px m-0'
                          // placeholder={t('Search')}
                          value={search}
                          onChange={e => {
                            setSearch(e.target.value);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className='col-lg-6'>
                <div className='input-group flex-nowrap'>
                  <span className='input-group-text  fw-bold'>{t('Category')}</span>
                  <Select
                    classNamePrefix='react-select'
                    className={`w-100 `}
                    isSearchable={true}
                    isClearable
                    options={UOMCLASSOPTIONS}
                    value={UOMCLASSOPTIONS?.find((f: any) => f.value === selectedValue)}
                    onChange={option => {
                      setSelectedValue(option?.value);
                    }}
                    placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                  />
                </div>
              </div>
            </div>

            <NtxTable
              data={tableData || []}
              columns={columns}
              dataPerPage={12}
              theadClass=''
              tableClass='table text-nowrap table-hover '
              // enableSearch
              // showRecordsSelector
            />
          </CardBody>
        </Loading>
      </Card>
    </div>
  );
};

export default Index;
